"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx = require("mobx");
exports.useStrict = mobx.configure ?
    (function (s) { return mobx.configure({ enforceActions: s ? "always" : "never" }); }) : mobx.useStrict;
exports.createAtom = mobx.createAtom ||
    (function (name, on, off) { return new mobx.Atom(name, on, off); });
exports.getGlobalState = mobx._getGlobalState || mobx.extras.getGlobalState;
//# sourceMappingURL=mobxShim.js.map